"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toMatchFnOrError = void 0;

var _fancyRegex = require("fancy-regex");

var _constants = require("./constants");

var _getHostRegex = require("./getHostRegex");

var _getPatternSegments = require("./getPatternSegments");

var _utils = require("./utils");

const toMatchFnOrError = (pattern, options) => {
  const {
    supportedSchemes,
    schemeStarMatchesWs,
    strict
  } = options;

  if (pattern === _constants.ALL_URLS) {
    return (0, _utils.createMatchFn)(url => {
      return (0, _fancyRegex.regex)`
				^
					(?:${supportedSchemes.map(_fancyRegex.regexEscape).join('|')})
					:
				$
			`.test(url.protocol);
    });
  }

  const patternSegments = (0, _getPatternSegments.getPatternSegments)(pattern);

  if (!patternSegments) {
    return new Error(`Pattern "${pattern}" is invalid`);
  }

  const {
    scheme,
    rawPathAndQuery
  } = patternSegments;
  /* Scheme */

  if (scheme !== '*' && !supportedSchemes.includes(scheme)) {
    return new Error(`Scheme "${scheme}" is not supported`);
  }

  const schemeRegex = (0, _fancyRegex.regex)`${scheme === '*' ? ['https?', schemeStarMatchesWs && 'wss?'].filter(Boolean).join('|') : scheme}:`;
  /* Host */

  const hostRegex = (0, _getHostRegex.getHostRegex)(patternSegments);

  if (hostRegex instanceof Error) {
    return hostRegex;
  }
  /* Path and query string */
  // Non-strict used for host permissions.
  // "The path must be present in a host permission, but is always treated as /*."
  // See https://developer.chrome.com/docs/extensions/mv3/match_patterns/


  const pathAndQuery = strict ? (0, _utils.normalizeUrlFragment)(rawPathAndQuery) : '/*';

  if (pathAndQuery instanceof Error) {
    return pathAndQuery;
  }

  const pathAndQueryRegex = (0, _fancyRegex.regex)`^${pathAndQuery.split('*').map(x => (0, _fancyRegex.regexEscape)(x)).join('.*')}$`;
  return (0, _utils.createMatchFn)(url => {
    // respect zero-search-string
    const pathAndQuery = url.pathname + (url.href.endsWith('?') ? '?' : url.search);
    return schemeRegex.test(url.protocol) && hostRegex.test(url.host) && pathAndQueryRegex.test(pathAndQuery);
  });
};

exports.toMatchFnOrError = toMatchFnOrError;